import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/organizationYEYCheckItemStatus/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/organizationYEYCheckItemStatus/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/organizationYEYCheckItemStatus/list',
    method: 'GET',
    params})
}

   

export function sync(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/sync',
    method: 'POST',
    data})
}

   

export function update(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/organizationYEYCheckItemStatus/update/batch',
    method: 'POST',
    data})
}

   